import React from 'react';
import PropTypes from 'prop-types';
import css from "./KioskHeader.css";
import KioskImage from "./KioskImage";
import CurrentWait from "./CurrentWait";
import { getServicePhotoUrl } from "../utils/images";

function KioskHeader(props) {
  const imageUrl = props.kioskImageUrl ? props.kioskImageUrl : getServicePhotoUrl(props.serviceUid);
  const imageSize = props.kioskImageUrl ? 'L' : 'M';

  return (
    <header className={css['header']} role="heading" aria-level="1">
      <div className={css['name-image']}>
        <div>
          <KioskImage size={imageSize} name={props.name} imageUrl={imageUrl} />
          <div aria-label={props.name} className={css['name']}>{props.name}</div>
        </div>
      </div>
      {props.showWaitTime && <CurrentWait 
        serviceId={props.serviceId} 
        studentId={props.studentId} 
        isProspectiveStudent={props.isProspectiveStudent} 
        email={props.email} 
        setError={props.setError}
      />}
    </header>
  );
}

KioskHeader.propTypes = {
  name: PropTypes.string.isRequired,
  kioskImageUrl: PropTypes.string,
  serviceUid: PropTypes.string,
  smallImage: PropTypes.bool,
  showWaitTime: PropTypes.bool.isRequired,
  serviceId: PropTypes.number,
  studentId: PropTypes.number,
  isProspectiveStudent: PropTypes.bool,
  email: PropTypes.string,
  setError: PropTypes.func.isRequired
};

export default KioskHeader;
